module.exports = __webpack_public_path__ + "img/s8sLogo3.b1b3928f.png";